import {
  IDashboardMember,
  IUserSettlementSuggestion,
} from '@/dataSource/src/api/groups/entities';

import {IBalanceItemMemberUI, IBalancesUI} from '../models/interfaces';

export const mapSettlementToBalances = (
  currentUserId: string,
  settlements: IUserSettlementSuggestion[],
  members: IDashboardMember[],
): IBalancesUI => {
  const memberMap = new Map(members.map(m => [m.split_user_id, m]));

  let owedAmount = 0;
  let oweAmount = 0;

  const owedMembers: IBalanceItemMemberUI[] = [];
  const oweMembers: IBalanceItemMemberUI[] = [];
  const defaultMember: IDashboardMember = {
    display_name: 'Unknown',
    modak_user_id: undefined,
    balance: 0,
    group_id: '',
    split_user_id: '',
    status: 'active',
  };

  settlements.forEach(s => {
    const fromMember = memberMap.get(s.from_id) || defaultMember;
    const toMember = memberMap.get(s.to_id) || defaultMember;

    if (s.to_id === currentUserId) {
      owedAmount += s.amount;
      owedMembers.push({
        id: s.from_id,
        name: fromMember.display_name,
        amount: s.amount,
        modakUserId: fromMember.modak_user_id,
      });
    }

    if (s.from_id === currentUserId) {
      oweAmount += s.amount;
      oweMembers.push({
        id: s.to_id,
        name: toMember.display_name,
        amount: s.amount,
        modakUserId: toMember.modak_user_id,
      });
    }
  });

  return {
    owed: {
      amount: owedAmount,
      members: owedMembers,
    },
    owe: {
      amount: oweAmount,
      members: oweMembers,
    },
  };
};
